'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { getEmailSubscriptionGroups, createGetEmailSubscriptionGroups } from 'reference-resolvers/api/EmailSubscriptionAPI';
export const createEmailSubscriptionGroupsReferenceResolver = options => {
  return createSimpleCachedReferenceResolver(Object.assign({
    cacheKey: CacheKeys.EMAIL_SUBSCRIPTION_GROUPS,
    createFetchData: createGetEmailSubscriptionGroups,
    fetchData: getEmailSubscriptionGroups,
    selectReferencesById: groups => groups.flatMap(g => g.getIn(['referencedObject', 'subscriptionTypes']))
  }, options));
};
export default createEmailSubscriptionGroupsReferenceResolver();